import { useEffect, useState } from "react";

/**
 * useViewportKind — classifies the viewport so the Home composition can swap
 * between three bespoke layouts. Aspect ratio + a width gate are used so
 * iPads (in either orientation) get the tablet composition, while small
 * phones still get the mobile-portrait layout.
 *
 *  • "mobile"  — phones (narrow + portrait): aspect < 1 AND width < 768px
 *  • "tablet"  — iPads & similar in any orientation (width ≥ 768px AND
 *                aspect between 2:3 and 3:2)
 *  • "desktop" — wide landscape monitors (aspect > 3:2)
 */
const MOBILE_QUERY = "(max-aspect-ratio: 1/1) and (max-width: 767px)";
const TABLET_QUERY =
  "(min-width: 768px) and (min-aspect-ratio: 2/3) and (max-aspect-ratio: 3/2)";

const compute = () => {
  if (typeof window === "undefined") return "desktop";
  if (window.matchMedia(MOBILE_QUERY).matches) return "mobile";
  if (window.matchMedia(TABLET_QUERY).matches) return "tablet";
  return "desktop";
};

export const useViewportKind = () => {
  const [kind, setKind] = useState(compute);

  useEffect(() => {
    const m = window.matchMedia(MOBILE_QUERY);
    const t = window.matchMedia(TABLET_QUERY);
    const handler = () => setKind(compute());
    m.addEventListener("change", handler);
    t.addEventListener("change", handler);
    return () => {
      m.removeEventListener("change", handler);
      t.removeEventListener("change", handler);
    };
  }, []);

  return kind;
};
